import { ApiBaseService } from "./ApiBaseService";
import type { Account } from "~/models/User";
import type { ApiResponse } from "~/types/ApiResponse";

export default class AccountService extends ApiBaseService {
    public list(): Promise<ApiResponse<Account[]>> {
        return this.request<ApiResponse<Account[]>>(
            this.route("api.account.list", "/accounts"),
            {
                method: "GET",
            },
        );
    }

    public info(): Promise<ApiResponse<Account>> {
        return this.request<ApiResponse<Account>>(
            this.route("api.account.info", "/account"),
            {
                method: "GET",
            },
        );
    }

    public create(
        data: Partial<
            Omit<Account, "domain" | "brand" | "location"> & {
                identifier: string;
                provider: string;
                domain_id: number;
                brand_id: number;
                location_id: number;
                brand_theme: any;
            }
        >,
    ): Promise<ApiResponse<Account>> {
        return this.request<ApiResponse<Account>>(
            this.route("api.account.store", "/account"),
            {
                headers: {
                    Accept: "application/json",
                },
                method: "POST",
                body: data,
            },
        );
    }

    public update(
        data: Partial<
            Omit<Account, "domain" | "brand" | "location" | "locale"> & {
                domain_id: number;
                brand_id: number;
                location_id: number;
                locale_id: number;
            }
        >,
    ): Promise<ApiResponse<Account>> {
        return this.request<ApiResponse<Account>>(
            this.route("api.account.update", "/account"),
            {
                headers: {
                    Accept: "application/json",
                },
                method: "PATCH",
                body: data,
            },
        );
    }
}
